import {translations} from 'presentation/translations-new';

const {searchProfessional, searchUnit, searchNeighborhood, searchExam} =
	translations['pt-br'].privateFlow.bookingFlow;

const SEARCH_BAR_PLACEHOLDER = {
	withGeo: ['', searchExam, searchUnit, searchProfessional, ''],
	withoutGeo: ['', searchExam, searchNeighborhood, searchUnit, searchProfessional, ''],
};

export {SEARCH_BAR_PLACEHOLDER};
